define([], () => ({
  REQUEST_SETTINGS: 'REQUEST_SETTINGS',
  RECEIVE_SETTINGS: 'RECEIVE_SETTINGS',
  ERROR_SETTINGS: 'ERROR_SETTINGS',
  UPDATE_SETTING: 'UPDATE_SETTING',

  UPDATE_ENABLE_APP: 'UPDATE_ENABLE_APP',
  UPDATE_DISABLE_APP: 'UPDATE_DISABLE_APP',

  REQUEST_APPS: 'REQUEST_APPS',
  RECEIVE_APPS: 'RECEIVE_APPS',
  ERROR_APPS: 'ERROR_APPS',
  UPDATE_APPS: 'UPDATE_APPS',

  RESIZE_MODAL: 'RESIZE_MODAL',
  UPDATE_APP_STATE: 'UPDATE_APP_STATE',

  // Notifications
  REQUEST_NOTIFICATIONS: 'REQUEST_NOTIFICATIONS',
  UPDATE_NOTIFICATIONS: 'UPDATE_NOTIFICATIONS',
  RECEIVE_NOTIFICATIONS: 'RECEIVE_NOTIFICATIONS',
  ERROR_NOTIFICATIONS: 'ERROR_NOTIFICATIONS',

  // Medias
  RECEIVE_MEDIAS: 'RECEIVE_MEDIAS',

  // Subscription data
  RECEIVE_TRIALING_INVENTORY: 'RECEIVE_TRIALING_INVENTORY',
}));
